import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Badge/sgds-badge";
import { register } from "../../utils/ce-registry";

register("sgds-badge", Component);

export default createComponent({
  react: React,
  tagName: "sgds-badge",
  elementClass: Component,
  events: {
    onSgdsShow: "sgds-show",
    onSgdsHide: "sgds-hide",
    onSgdsAfterShow: "sgds-after-show",
    onSgdsAfterHide: "sgds-after-hide"
  }
});
